
function Sidebar() {
    return (
        <div id="profile">
            
        </div>
    );
}

export default Sidebar;